import type { FaireProductEntity } from "../../entity_types/product";

export const p_7eya9hq4c9: FaireProductEntity = {
  token: "p_7eya9hq4c9",
  type: "product",
  name: "Good Sunset Candle",
  brandToken: "b_hhm5ztnc4f",
  brandName: "Good Olfactory Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/4e4e3e31ae2dc3b080f238c31ffbbd60204751e7699e1b1d0b1e1da06ebab8db.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/025050239d3101c52134ef7363f87d48561913cf11aa715818f3661e6dbc8237.jpeg",
  ],
  priceDollars: 14,
  description:
    "\nIntroducing Good Sunset, our tribute to the golden hour. This candle is an intricate blend of champagne, lychee, bergamot, coastal rose, wild jasmine, and amber—designed for those who live for moments of pure, unadulterated beauty. It’s the exhilaration of a toast at twilight, the beginning of an unforgettable evening.\n\nGood Sunset is an invitation to savor the fleeting moments of dusk, where the sky is painted in hues of gold and pink, and time seems to stand still. Light it to bring the essence of sunset into your space, transforming it into a refuge of calm and sophisticated warmth. Perfect for winding down after a busy day, this candle is all about bringing a touch of sunset magic to your everyday life.\n\nKey notes: Lychee, Champagne // Bergamot // Coastal Rose, Wild Jasmine\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:04.191Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
